export default __webpack_public_path__ + "media/AshokGoel.d30877e0.png";